import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {IonicModule} from '@ionic/angular';
import {ItemModule} from '../../../../../core/component/item/item.module';
import {PartnerSummaryFieldComponent} from './partner-summary-field.component';
import {SummaryFieldModule} from '../../../../../core/component/summary-field/summary-field.module';
import {
    TagsSummaryFieldComponent
} from "../../../../../common/tag/api/components/tags-summary-field/tags-summary-field.component";

@NgModule({
    imports: [
        CommonModule,
        IonicModule,
        ItemModule,
        SummaryFieldModule,
        TagsSummaryFieldComponent,
    ],
    declarations: [
        PartnerSummaryFieldComponent,
    ],
    exports: [
        PartnerSummaryFieldComponent
    ],
})
export class PartnerSummaryFieldModule {
}